var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 20-4.5-3.6-.9 1.2 5.4 4.4 5.5-4.4-.9-1.2zm0-16 4.5 3.6.9-1.2-5.4-4.4-5.5 4.4.9 1.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpDown);
export default __webpack_public_path__ + "static/media/chevron-up-down.db10e0e0a1295cc1ad499afd95ecfcaf.svg";
export { ForwardRef as ReactComponent };